/*=========================================================================================
  File Name: moduleScheduleMutations.js
  Description: Schedule Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	SET_STANDARD_OUTPUT(state, standardOutput) {
		Object.assign(state.standardOutput, standardOutput);
	},
	SAVE_ROUTING_DONE(state, rountingData) {
		if (rountingData.routings_done) {
			state.rountingsDoneMap.set(rountingData.upload_file_id, rountingData.routings_done);
		}
	},
	UPDATE_ROUTING_DONE(state, rountingData) {
		state.rountingsDoneMap.set(rountingData.upload_file_id, rountingData.routings_done);
	},
	DELETE_ROUTING_DONE(state, {key, upload_file_id}) {
		// map.delete(clave)
		if (state.rountingsDoneMap.has(upload_file_id)) {
			const curretsRouting = state.rountingsDoneMap.get(upload_file_id).filter((routing) => routing.key !== key);
			state.rountingsDoneMap.set(upload_file_id, curretsRouting);
		}
	},
};
